import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, MessageSquare } from 'lucide-react';
import { BRAND } from '@/data/site';

export default function Hero() {
  return (
    <section
      className="relative overflow-hidden bg-ohana-primary text-ohana-bg"
      data-testid="home-hero"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1723639904962-e138009b2582?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400)',
        }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 bg-gradient-to-r from-ohana-primary/95 via-ohana-primary/85 to-ohana-primary/65"
        aria-hidden="true"
      />
      <div className="absolute inset-0 hero-noise opacity-50" aria-hidden="true" />

      <div className="relative container-ohana py-24 md:py-36 lg:py-44">
        <div className="max-w-3xl">
          <p className="overline !text-ohana-accent" data-testid="hero-eyebrow">
            Property Transition Specialists · Columbus, Indiana
          </p>
          <h1
            className="mt-5 font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight"
            data-testid="hero-headline"
          >
            We Help Families Navigate <br className="hidden md:block" />
            <span className="text-ohana-accent">Life&rsquo;s Most Difficult Property Transitions.</span>
          </h1>
          <p className="mt-7 text-lg md:text-xl text-ohana-bg/80 leading-relaxed max-w-2xl">
            Estate cleanouts, senior downsizing, inherited properties, pre-listing prep, and property clearing. Handled with expertise, compassion, and respect for Central Indiana families, realtors, estate executors, and property managers.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/contact" className="btn-primary" data-testid="hero-cta-quote">
              Get My Free Quote
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
            <a
              href={`tel:${BRAND.phoneTel}`}
              className="btn-ghost-light"
              data-testid="hero-cta-call"
            >
              <Phone className="mr-2 h-4 w-4" />
              Call {BRAND.phone}
            </a>
          </div>
          <p
            className="mt-5 text-sm font-medium tracking-wide text-ohana-bg/85"
            data-testid="hero-trust-line"
          >
            Woman-Owned · MBE &amp; WBE Certified · Licensed &amp; Insured · Bartholomew County Disposal
          </p>
          <a
            href={`sms:${BRAND.phoneSms}`}
            className="mt-4 inline-flex items-center gap-2 text-sm text-ohana-bg/75 hover:text-white transition"
            data-testid="hero-cta-text"
          >
            <MessageSquare className="h-4 w-4 text-ohana-accent" />
            Or text us at the same number
          </a>
        </div>
      </div>
    </section>
  );
}
